import * as React from 'react'
import { useOutletContext, useParams } from 'react-router-dom'

import moment from 'moment'

import { observer } from 'mobx-react'

import { PortalWrapper } from 'modules/core/components/PortalWrapper'
import i18n from 'modules/core/lib/i18n'

import { ContractVersionsProvider } from 'modules/contracts/lib/contractVersionsContext'
import {
  filterContractVersionsByCurrent,
  getUpcomingContractVersions,
} from 'modules/contracts/lib/utils'
import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import contractVersionsPayrollPolicies, {
  ContractVersionsPayrollPoliciesProvider,
} from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import Actions from 'modules/employees/components/Actions'
import type { CommonRouteContext } from 'modules/employees/lib/types'
import Page from 'modules/layout/components/Page'
import Header from 'modules/layout/components/Page/Header'
import policies, { PoliciesProvider } from 'modules/payroll_bundle/store/collections/policies'

import Body from './_Body'

interface Props {
  contractVersions: ContractVersions
}

const Card = observer(({ contractVersions }: Props) => {
  const { employee, cardEmployeeRight, headerTitle } = useOutletContext<CommonRouteContext>()
  const { contractVersionId } = useParams()
  const employeeId = employee.attributes.id

  function getContractVersion() {
    const today = moment()
    const contractVersion = contractVersions.get(Number(contractVersionId))

    if (contractVersion) return contractVersion

    const models = contractVersions.filter({
      employee_id: employeeId,
    })

    const current = filterContractVersionsByCurrent(models, today)[0]

    if (current) return current

    return getUpcomingContractVersions(models, today)
  }

  const contractVersion = getContractVersion()

  return (
    // NOTE: <Page.Body> has been omitted intentionally because it applies some margin that
    //       was not there before the refactor of the portals.
    <>
      <PortalWrapper container={cardEmployeeRight}>
        <Actions employee={employee} contractVersions={contractVersions} />
      </PortalWrapper>
      <PortalWrapper container={headerTitle}>
        <Header.Title>{i18n.t('admin_employee.contracts')}</Header.Title>
      </PortalWrapper>
      <PoliciesProvider collection={policies}>
        <ContractVersionsProvider collection={contractVersions}>
          <ContractVersionsPayrollPoliciesProvider collection={contractVersionsPayrollPolicies}>
            <Page.Body>
              <Body employee={employee} contractVersion={contractVersion} />
            </Page.Body>
          </ContractVersionsPayrollPoliciesProvider>
        </ContractVersionsProvider>
      </PoliciesProvider>
    </>
  )
})

export default Card
